<template>
  <SignatureDialogLayout title="Forma de pagamento">

    <div v-if="false" style="border-radius: 6px; background-color: #fff; padding: 10px; margin-bottom: 18px; overflow: hidden;">
      <div style="overflow: hidden; float: left;">
        <v-chip label color="red" text-color="white" style="float: left;">ATENÇÃO:</v-chip><marquee style="width: calc(100% - 90px); margin: 3px; float: left;">Você ganhou um cupom para <b>10% DE DESCONTO</b> válido para todos os planos! Esta oferta é por tempo limitado, expira em <b>22 MINUTOS.</b></marquee>
      </div>
      <div style="font-size: 17px; float: left; width: 100%; margin-top: 10px; padding-top: 10px; border-top: 1px solid #dddddd; overflow: hidden;">
        <div style="border-radius: 6px; background-color: #eee; width: 100px; padding: 6px; float: left; font-weight: bold; text-align: center;">
          CHECK10
        </div>
        <small style="float: left; width: calc(100% - 105px); padding-left: 8px">Utilize esse cupom e comece a turbinar suas vendas hoje mesmo!</small>
      </div>
    </div>

    <div v-if="false" class="section-header">Cupom de desconto</div>

    <div v-if="coupon" class="coupon">
      <template v-if="coupon?.partnership_campaign?.partnership?.url_logo">
        <div class="logo">
          <img :src="coupon.partnership_campaign.partnership.url_logo" />
        </div>
        <div class="stroke"></div>
      </template>
      <div class="description">
        <p>Parabéns, você ganhou</p>
        <p class="discount">{{ discountText }} DESCONTO</p>
      </div>
    </div>

    <div v-if="false" class="mb-5 mt-3">
      <div class="coupon-input-group">
        <input v-model="couponCode" type="text" placeholder="Digite o código" />
        <button @click="handleCouponSearch">
          <VIcon color="#48b48d">mdi-plus-circle</VIcon>
        </button>
      </div>
      <div v-if="couponError" class="coupon-error">Cupom inválido ou expirado</div>
    </div>

    <div class="month-bonus-banner">
      <div class="month-bonus-title">
        BÔNUS DO MÊS <b style="background-color: #fff; color: #48B48D; border-radius: 6px; padding: 0px 8px; float: right; margin-top: -2px;">{{ new Date().toLocaleString('pt-BR', { month: 'long' }).toUpperCase() }} / {{ new Date().getFullYear() }}</b>
      </div>
      <div class="month-bonus-content">
        <b style="font-size: 17px;">Ativando este mês você garante:</b>
        <div class="mt-2">
          <span>GRÁTIS</span> Personalização e configuração;
        </div>
        <div class="mt-2">
          <span>GRÁTIS</span> Treinamento gerencial (60 minutos);
        </div>
        <div class="mt-2">
          <span>GRÁTIS</span> Treinamento operacional (60 minutos);
        </div>
        <div class="mt-2">
          <span>GRÁTIS</span> Grupo para suporte rápido (WhatsApp);
        </div>
      </div>
      <div class="month-bonus-footer">
        *Válido somente para ativações realizadas no mês atual.
      </div>
    </div>

    <template v-if="totalPrice > 0">
      <div class="section-header mt-4">Selecione o pagamento</div>

      <div class="payment-methods">
        <div v-for="payment in filteredPaymentMethods" :key="payment.method" class="payment" @click="handleSelectPaymentMethod(payment)">
          <div>
            <VIcon color="#8D97A0">{{ payment.icon }}</VIcon>
          </div>
          <div class="description">{{ payment.name }}</div>
          <div><VIcon>mdi-chevron-right</VIcon></div>
        </div>
      </div>
    </template>

    <template #footer>
      <SignatureResume>
        <template #actions>
          <VBtn depressed @click="handleClickBack">Voltar</VBtn>
          <VBtn v-if="totalPrice === 0" color="primary" depressed @click="handleSaveFreePayment">Finalizar</VBtn>
        </template>
      </SignatureResume>
    </template>
  </SignatureDialogLayout>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import PartnershipCouponService from '@/services/api/partnershipCoupon';
import SignatureDialogLayout from '../SignatureDialogLayout';
import SignatureResume from '../SignatureResume';

export default {
  name: 'StepSelectPlan',
  components: { SignatureDialogLayout, SignatureResume },
  data() {
    return {
      couponCode: '',
      couponError: false,
      paymentMethods: [
        {
          name: 'Cartão de crédito',
          icon: 'mdi-credit-card-outline',
          method: 'CREDIT_CARD',
          discount: 2
        },
        {
          name: 'Boleto Bancário',
          icon: 'mdi-barcode-scan',
          method: 'BOLETO'
        },
        {
          name: 'Pix',
          icon: 'mdi-qrcode',
          method: 'PIX'
        }
      ]
    };
  },
  computed: {
    ...mapState('Payment', ['selectedPlan', 'cycle', 'coupon', 'totalPrice']),
    filteredPaymentMethods() {
      if (this.cycle && this.cycle === 'MONTHLY') {
        return this.paymentMethods.filter(method => method.method === 'CREDIT_CARD' || method.method === 'PIX');
      }
      return this.paymentMethods.filter(method =>
        method.method === 'BOLETO' || method.method === 'PIX'
      );
    },
    discountText() {
      if (!this.coupon) return '';

      if (this.coupon.discount_type === 'percentage') {
        return `${this.coupon?.discount_value?.replace('.00', '')}%`;
      }

      return `R$${this.coupon.discount_value ?? 0}`.replace('.00', '');
    }
  },
  methods: {
    ...mapActions('Payment', ['setCoupon', 'setLoading']),
    handleSelectPaymentMethod(payment) {
      this.$emit('selected', payment.method);
      this.couponError = false;
    },
    handleSaveFreePayment() {
      this.handleSelectPaymentMethod({ method: 'FREE' });
    },
    handleClickBack() {
      this.$emit('back');
      this.couponError = false;
    },
    async handleCouponSearch() {
      try {
        this.setLoading(true);
        const { data } = await PartnershipCouponService.search({
          code: String(this.couponCode).trim(),
          planId: Number(this.selectedPlan.id),
          cycle: String(this.cycle).trim()
        });

        this.setCoupon(data);
      } finally {
        this.couponError = true;
        this.setLoading(false);
      }
    }
  }
};
</script>
<style lang="scss">
.payment-methods {
  .payment {
    display: flex;
    gap: 16px;
    padding: 12px;
    background-color: #fff;
    border-radius: 8px;
    margin: 8px 0px;
    align-items: center;
    cursor: pointer;

    .description {
      flex-grow: 1;
      color: #3f505f;
      font-size: 14px;
      font-weight: 600;
    }

    .discount {
      color: #e8663d;
      font-size: 12px;
      font-weight: 600;
      text-transform: uppercase;
    }
  }
}

.month-bonus-banner {
  background-color: #48B48D;
  color: #fff;
  padding: 10px;
  border-radius: 10px;

  .month-bonus-title {
    font-size: 19px;
    margin-bottom: 6px;
    padding: 4px;
  }

  .month-bonus-content {
    background-color: #fff;
    padding: 10px;
    border-radius: 10px;
    color: #3f505f !important;
    font-size: 15px;

    span {
      margin-top: 5px;
      background-color: #48B48D;
      color: #fff;
      padding: 2px 8px;
      border-radius: 6px;
      font-size: 14px;
    }
  }

  .month-bonus-footer {
    margin-top: 6px;
    font-size: 14px;
    padding: 4px 0px;
  }
}

.coupon {
  border-radius: 8px;
  background: #fff;
  padding: 0 16px;
  display: flex;
  margin: 15px 0;
  align-items: center;

  .logo {
    padding: 14px;

    img {
      width: 100px;
      height: 80px;
      object-fit: contain;
    }
  }

  .description {
    padding: 16px;
    color: #3f505f;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    flex-grow: 1;
    p {
      margin: 0;
    }

    p.discount {
      color: #48b48d;
      font-size: 18px;
      font-weight: 700;
    }
  }

  .stroke {
    border-left: 2px dashed #bac0c5;
    align-self: stretch;
  }
}

.coupon-input-group {
  display: flex;
  flex-direction: row;
  gap: 12px;

  input {
    flex-grow: 1;
    border-radius: 6px;
    border: 1px solid #d5d7dd;
    background: #fff;
    padding: 8px 12px;
    color: #6e7481;
    font-size: 16px;
    font-weight: 400;
  }

  button {
    padding: 8px;
    display: flex;
    padding: 8px;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    border: 1px solid #48b48d;
  }
}

.coupon-error {
  margin-top: 4px;
  color: #d63928;
  font-size: 14px;
  font-weight: 400;
}
</style>
